import { useState } from 'react';
//import { Checkbox } from "@mui/material"
import { Checkbox } from 'rsuite';
import { RowNode } from 'ag-grid-community';
import { Device } from '../../shared/generated';
interface ICellEditor {
    value: any;
    onValueChange: any;
    stopEditing: any;
    node: RowNode<Device>
}
export default function CellEditor(props: ICellEditor) {
    const { value, onValueChange, stopEditing, node } = props;
    const row = node;
    const [checked, setChecked] = useState(value);
    const onChange = () => {
        setChecked(!checked);
        onValueChange(!checked);
        stopEditing();
    };
    const banned = row.data?.Banned;
    const blocked = row.data?.Blocked;
    const color = banned ? "var(--text-dark)" : (blocked ? "var(--text-dark)" : 'var(--text)');
    return <Checkbox style={{ color: color, padding:'5px' }} /*onBlur={onBlur}*/ onChange={onChange} checked={checked} />;
}